import { render, staticRenderFns } from "./orderpay.vue?vue&type=template&id=563f9226&scoped=true"
import script from "./orderpay.vue?vue&type=script&lang=js"
export * from "./orderpay.vue?vue&type=script&lang=js"
import style0 from "./orderpay.vue?vue&type=style&index=0&id=563f9226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f9226",
  null
  
)

export default component.exports